import {makeStyles} from "@material-ui/core";

export default function PedidosListaCss() {
    return makeStyles(theme => ({
        root: {
            marginTop: 20
        }
    }));
}